import { Component, output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'era-device-scheduled-tasks-cancel-ui',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './device-scheduled-tasks-cancel.component.html',
})
export class DeviceScheduledTasksCancelComponent {
  public readonly cancelled = output();

  public onCancel() {
    this.cancelled.emit();
  }
}
